import { Component, ViewChild } from "@angular/core";
import { CatalogPaginationRequest } from "src/app/features/shared/models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "src/app/features/shared/models/Filter/FilterRequest";
import { firstValueFrom, Observable, Subscription, take } from "rxjs";
import { table } from "console";
import { AlarmDashboardCatalogKeys } from "../../model/AlarmDashboardCatalogKeys";
import { DashboardAlarmsRequest } from "../../model/DashboardAlarmsRequest";
import { AlarmDashboardTableRequest } from "../../model/AlarmDashboardTableRequest";
import { MainDashboardResumeDTO } from "../../model/MainDashboardResumeDTO";
import { ControlPanelService } from "../../services/ControlPanel.service";
import { EnumAlarmCategoriesIcons, EnumAlarmCategoriesValues, EnumAlarmCategory } from "src/app/features/shared/helpers/enums/EnumAlarmCategories";

@Component({
  selector: "main-dashboard-page",
  templateUrl: "./main-dashboard-page.component.html",
  styleUrls: ["./main-dashboard-page.component.css"],
})
export class MainDashboardPageComponent {
  dashboardDataResponse: MainDashboardResumeDTO = {
    totalUsers: 0,
    totalLocations: 0,
    totalLocationsByGPS: 0,
    totalGeofences: 0,
    totalLocations_Actives: 0,
    totalLocations_Inactives: 0,
    totalLocations_NoReport: 0,
    alarms: []
  };

  // dummyDashboardAlarms: DashboardAlarmsRequest[] = [
  //   { Total: 50, 
  //     AlarmName: "Desconexiones", 
  //     AlarmedPerDay: [2, 5, 1, 0, 8, 3, 7, 4, 6, 5, 9, 2, 1, 0, 4, 3, 5, 6, 7, 8, 9, 4, 3, 2, 1, 0, 5, 6, 7, 8] 
  //   },
  //   { Total: 89, 
  //     AlarmName: "Batería baja", 
  //     AlarmedPerDay: [1, 3, 4, 2, 5, 6, 4, 3, 2, 1, 0, 2, 3, 4, 5, 6, 7, 8, 5, 4, 3, 2, 1, 0, 1, 2, 3, 4, 5, 6] 
  //   },
  //   { Total: 18, 
  //     AlarmName: "Velocidad", 
  //     AlarmedPerDay: [0,0,0,0,0,0,0,0,1,0,0,0,2,0,1,0,0,3,0,1,0,0,0,0,0,0,0,1,0,5] 
  //   },
  //   { Total: 30, 
  //     AlarmName: "Geocerca", 
  //     AlarmedPerDay: [10,5,3,2,1,0,0,0,0,0,0,0,0,0,0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15] 
  //   }
  // ];

  date = "";

  subscription_getResumeData: Subscription;

  constructor(private controlPanelService: ControlPanelService) {
  }

  ngOnInit() {
    this.date = this.getShortDate();
  }

  ngAfterViewInit(): void {
    this.EndSubscriptions();
    this.controlPanelService.getResume().subscribe((data) => {
      if (data.isSuccess) {
        this.dashboardDataResponse = data.result;
        //datos dummy
        // this.dashboardDataResponse.alarms = this.dummyDashboardAlarms;
        // this.dashboardDataResponse.totalGeofences = 12;
      }
    });
  }

  ngOnDestroy(): void {
    this.EndSubscriptions();
  }

  EndSubscriptions() {
    if (this.subscription_getResumeData)
      this.subscription_getResumeData.unsubscribe();
  }

  getShortDate(): string {
    const date = new Date();
    return date.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' });
  }

}
